{
  "common": {
    "save": "保存",
    "cancel": "取消",
    "delete": "删除",
    "edit": "编辑",
    "create": "创建",
    "loading": "加载中...",
    "saving": "保存中...",
    "error": "错误",
    "success": "成功",
    "confirm": "确认",
    "back": "返回",
    "next": "下一步",
    "continue": "继续",
    "close": "关闭",
    "search": "搜索",
    "yes": "是",
    "no": "否",
    "ok": "好的",
    "retry": "重试",
    "more": "更多",
    "remove": "移除",
    "rename": "重命名",
    "discard": "舍弃",
    "submit": "提交",
    "send": "发送",
    "copy": "复制",
    "copied": "已复制",
    "settings": "设置",
    "or": "或",
    "and": "和",
    "untitled": "未命名",
    "anonymous": "匿名",
    "required": "必填",
    "optional": "选填"
  },
  "nav": {
    "dashboard": "仪表盘",
    "tasks": "任务",
    "apps": "应用",
    "chats": "聊天",
    "users": "用户",
    "settings": "设置",
    "general": "通用",
    "pages": "页面",
    "other": "其他"
  },
  "auth": {
    "signIn": "登录",
    "signOut": "退出登录",
    "signUp": "注册",
    "forgotPassword": "忘记密码",
    "email": "邮箱",
    "emailPlaceholder": "you@company.com",
    "password": "密码",
    "rememberMe": "记住我",
    "welcomeBack": "欢迎回来",
    "signInToAccount": "登录您的 Glyde 账户",
    "continueWithGoogle": "使用 Google 账户继续",
    "continueWithGithub": "使用 GitHub 账户继续",
    "noAccount": "还没有账户？",
    "alreadyHaveAccount": "已有账户？",
    "enterVerificationCode": "输入验证码",
    "verifyEmailTitle": "验证您的邮箱",
    "verifyEmailSubtitle": "请输入我们发送到 {{email}} 的验证码",
    "verificationCodeLabel": "验证码",
    "verifying": "验证中...",
    "verificationCodeSent": "我们已向 <strong>{{email}}</strong> 发送了 6 位验证码",
    "verifyAndSignIn": "验证并登录",
    "resendCode": "重新发送",
    "changeEmail": "修改邮箱",
    "checkingAuthentication": "正在验证身份...",
    "emailRequired": "请输入邮箱地址",
    "emailInvalid": "请输入有效的邮箱地址",
    "codeRequired": "请输入 6 位验证码",
    "emailVerified": "邮箱验证成功！请登录以继续。",
    "signedInSuccess": "登录成功！",
    "twoFactorRequired": "需要进行两步验证。",
    "codeSent": "验证码已发送！",
    "codeResent": "验证码已重新发送！",
    "resendFailed": "重新发送失败",
    "verificationFailed": "验证失败：{{message}}",
    "failedSendCode": "验证码发送失败",
    "noAccountFound": "未找到该邮箱对应的账号，请先注册。",
    "otpExpired": "验证码已过期，请重新获取。",
    "invalidOtp": "验证码不正确，请重新输入。",
    "tooManyAttempts": "尝试次数过多，请稍后再试。",
    "signInFailed": "登录失败，请稍后重试。",
    "authTimedOut": "登录超时，请重试。",
    "sessionCouldNotEstablish": "登录成功但无法建立会话，请重试。",
    "forgotPasswordTitle": "忘记密码？",
    "forgotPasswordDescription": "输入您的邮箱，我们将发送密码重置链接。",
    "resetPassword": "重置密码",
    "newPassword": "新密码",
    "confirmPassword": "确认密码",
    "signUpTitle": "创建账户",
    "signUpDescription": "免费开始使用 Glyde。",
    "name": "姓名",
    "namePlaceholder": "您的姓名",
    "agreeTerms": "注册即表示您同意我们的<terms>服务条款</terms>和<privacy>隐私政策</privacy>。"
  },
  "settings": {
    "title": "设置",
    "general": "通用",
    "profile": "个人资料",
    "workspace": "工作区",
    "language": "语言",
    "languageDescription": "选择界面显示的语言。",
    "theme": "主题",
    "themeLight": "浅色",
    "themeDark": "深色",
    "themeSystem": "跟随系统",
    "deleteWorkspace": "删除工作区",
    "workspaceName": "工作区名称",
    "taskCodePrefix": "任务编号前缀",
    "taskCodePrefixDescription": "为任务编号设置自定义前缀。任务编号将显示为 {{prefix}}-1、{{prefix}}-2 等。留空则使用从工作区名称生成的默认前缀。",
    "taskCodePrefixDefault": "默认：{{prefix}}（来源于工作区名称）",
    "taskCodePrefixLabel": "前缀",
    "taskCodePrefixPreview": "预览：",
    "saveTaskCodePrefix": "保存前缀",
    "taskCodePrefixUpdated": "任务编号前缀已更新",
    "taskCodePrefixFailed": "任务编号前缀更新失败",
    "workspaceDescription": "工作区可帮助您组织文档。",
    "members": "成员",
    "billing": "账单",
    "security": "安全",
    "apiKeys": "API 密钥",
    "integrations": "集成",
    "auditLogs": "审计日志",
    "profileDescription": "管理您的个人资料信息。",
    "displayName": "显示名称",
    "avatar": "头像",
    "uploadAvatar": "上传头像",
    "removeAvatar": "移除头像"
  },
  "workspace": {
    "switch": "切换工作区",
    "create": "新建工作区",
    "name": "名称",
    "description": "描述"
  },
  "topics": {
    "addTopic": "添加主题",
    "newTopic": "新主题",
    "topicTitle": "主题标题",
    "topicTitlePlaceholder": "请输入主题标题",
    "deleteTopic": "删除主题",
    "deleteTopicConfirm": "确定要删除这个主题吗？",
    "deleteTopicWarning": "此操作无法撤销。这将永久删除该主题及其所有内容。",
    "topicCreated": "主题创建成功",
    "topicDeleted": "主题删除成功",
    "topicCreateFailed": "主题创建失败",
    "topicDeleteFailed": "主题删除失败",
    "emptyTopicTitle": "暂无主题",
    "emptyTopicDescription": "创建您的第一个主题，开始整理文档。",
    "createFirstTopic": "创建第一个主题",
    "emptySectionTitle": "空白章节",
    "emptySectionDescription": "为该章节添加内容或创建子主题。",
    "deleteConfirm": "确定要删除「{{title}}」吗？",
    "deleteWithSubtopics": "警告：这将同时删除 {{count}} 个子主题。",
    "deleting": "删除中...",
    "unableToDelete": "无法删除主题",
    "deleteFailed": "主题删除失败：{{message}}",
    "addToSection": "添加到「{{section}}」",
    "addToChangelog": "添加到「{{section}}」更新日志",
    "addToApi": "添加到「{{section}}」API",
    "navCreate": "创建",
    "navCreateDesc": "创建新主题或使用模板",
    "navRecording": "录制",
    "navRecordingDesc": "通过屏幕录制创建",
    "navImportOpenApi": "OpenAPI/Swagger",
    "navImportOpenApiDesc": "导入 API 文档",
    "navImportFromSources": "从源导入",
    "navImportFromSourcesDesc": "从已连接的数据源导入",
    "navSupportTickets": "支持工单",
    "navSupportTicketsDesc": "从支持工单创建",
    "navChangelogCreate": "创建",
    "navChangelogCreateDesc": "创建新的更新日志条目或主题",
    "navImportGitHub": "从 GitHub 导入",
    "navImportGitHubDesc": "导入 GitHub 发布版本",
    "navCreateApiDesc": "创建新主题",
    "navImportOpenApiSpec": "导入 OpenAPI",
    "navImportOpenApiSpecDesc": "通过 OpenAPI 规范导入 API 文档",
    "comingSoon": "即将推出"
  },
  "sections": {
    "createFirstSection": "创建您的第一个章节",
    "configureSection": "配置章节",
    "chooseTemplate": "选择一个模板来组织您的文档",
    "customizeDetails": "自定义章节信息",
    "selectTemplate": "请选择一个模板",
    "sectionTitle": "章节标题",
    "sectionTitlePlaceholder": "请输入章节标题",
    "sectionTitleDescription": "文档章节的主要标题",
    "urlSlugOptional": "URL 别名（可选）",
    "urlSlugPlaceholder": "custom-url-slug",
    "urlSlugDescription": "留空则根据标题自动生成",
    "change": "更改",
    "createSection": "创建章节",
    "sectionCreated": "章节创建成功",
    "createSectionFailed": "章节创建失败",
    "topicsCreated": "已创建 {{count}} 个主题",
    "placeholdersReady": "{{count}} 个占位符已准备好导入",
    "templateCreationUnavailable": "模板创建不可用，将创建普通章节"
  },
  "recording": {
    "newRecording": "新录制",
    "startRecording": "开始录制",
    "stopRecording": "停止录制",
    "pauseRecording": "暂停录制",
    "resumeRecording": "继续录制",
    "cancelRecording": "取消录制",
    "recording": "录制中",
    "paused": "已暂停"
  },
  "loading": {
    "page": "页面加载中...",
    "content": "内容加载中..."
  },
  "errors": {
    "generic": "发生错误，请稍后重试。",
    "network": "网络错误，请检查网络连接。",
    "unauthorized": "您无权执行此操作。",
    "notFound": "未找到。",
    "sessionExpired": "会话已过期，请重新登录。",
    "tryAgain": "请重试。",
    "unknownError": "未知错误"
  },
  "sidebar": {
    "mySpace": "我的空间",
    "workspaces": "工作区",
    "team": "团队",
    "integrations": "集成",
    "settings": "设置",
    "newSop": "新建 SOP",
    "newWorkspace": "新建工作区",
    "newWorkspaceDescription": "创建工作区来组织您的 SOP。",
    "titleLabel": "名称",
    "titlePlaceholder": "例如：产品文档",
    "descriptionLabel": "描述",
    "descriptionOptional": "（可选）",
    "descriptionPlaceholder": "这个工作区是用来做什么的？",
    "colorLabel": "颜色",
    "creating": "创建中..."
  },
  "dashboard": {
    "mySpace": "我的空间",
    "dashboard": "仪表盘",
    "subtitle": "您在所有工作区的 SOP。",
    "importVideo": "导入视频",
    "newSop": "新建 SOP",
    "sops": "SOP",
    "workspace": "工作区",
    "workspaces": "工作区",
    "shared": "已共享",
    "tabAll": "全部",
    "tabMine": "我的 SOP",
    "tabShared": "共享给我的",
    "searchPlaceholder": "搜索 SOP...",
    "emptyTitle": "还没有 SOP",
    "emptyMine": "通过录制屏幕或导入视频来创建您的第一个 SOP。",
    "emptyShared": "还没有人向您共享 SOP。",
    "emptyAll": "您的工作区中还没有 SOP。",
    "getExtension": "获取扩展",
    "recordScreen": "录制屏幕",
    "getExtensionDescription": "安装 Chrome 扩展以开始录制。",
    "recordScreenDescription": "录制您的屏幕，自动生成 SOP。",
    "installExtension": "安装扩展",
    "newRecording": "新建录制",
    "importVideoCardTitle": "导入视频",
    "importVideoCardDescription": "上传现有视频将其转换为 SOP。",
    "addIntegrationsTitle": "添加集成",
    "addIntegrationsDescription": "我们的集成包括 Notion、Confluence、Google Drive。",
    "viewIntegrations": "查看集成",
    "tableTitle": "标题",
    "tableApplication": "应用",
    "tableWorkspace": "工作区",
    "tableCreatedBy": "创建者",
    "tableLastModified": "最后修改",
    "tableAction": "操作",
    "loadingSops": "加载 SOP 中...",
    "noSopsFound": "未找到 SOP",
    "tryAdjustingSearch": "尝试调整您的搜索词。",
    "untitledSop": "未命名 SOP",
    "addToWorkspace": "添加到工作区",
    "delete": "删除",
    "previous": "上一页",
    "next": "下一页",
    "pageOf": "第 {{page}} 页，共 {{total}} 页",
    "deleteSopTitle": "删除 SOP",
    "deleteSopDesc": "确定要删除「{{title}}」吗？此操作无法撤销。",
    "sopDeleted": "SOP 已删除",
    "sopDeleteFailed": "删除 SOP 失败：{{error}}",
    "upgradeFeatureName": "添加到工作区",
    "upgradeFeatureDescription": "跨多个工作区共享 SOP，保持团队同步。",
    "upgradeBenefit1": "共享 SOP 到任意工作区",
    "upgradeBenefit2": "无限工作区",
    "upgradeBenefit3": "跨团队协作"
  },
  "team": {
    "title": "团队",
    "subtitle": "管理团队成员及其角色。",
    "searchPlaceholder": "搜索团队成员...",
    "invite": "邀请",
    "noPermissionInvite": "您没有邀请成员的权限",
    "invitationSent": "邀请已发送",
    "invitationFailed": "邀请发送失败：{{error}}",
    "referralSent": "已向 {{email}} 发送推荐",
    "referralFailed": "推荐发送失败",
    "defaultInviteMessage": "嗨，我正在使用 {{appName}} 通过 AI 把屏幕录制转换成精美的 SOP。加入工作区，我们一起搭建和共享文档吧。",
    "referTitle": "推荐同事",
    "referDescription": "他们将获得自己的免费 {{appName}} 工作区。",
    "referCollaborateQuestion": "想在同一个工作区协作吗？",
    "referUpgradeButton": "升级到 Pro",
    "sendReferral": "发送推荐",
    "sendingReferral": "发送中...",
    "inviteTitle": "邀请团队成员",
    "inviteDescription": "发送邀请加入您的工作区",
    "emailLabel": "邮箱地址",
    "emailPlaceholder": "colleague@company.com",
    "roleLabel": "角色",
    "selectRole": "选择角色",
    "roleMemberOption": "成员 — 可以编辑内容",
    "roleAdminOption": "管理员 — 可以管理成员",
    "roleAdminHint": "管理员可以管理成员和工作区设置",
    "roleMemberHint": "成员可以创建、编辑和发布 SOP",
    "personalNote": "个人留言",
    "personalNoteOptional": "个人留言（可选）",
    "personalNotePlaceholder": "为邀请添加一条个人留言...",
    "referralNotePlaceholder": "嗨，你应该试试这个用于 SOP 和文档...",
    "sendInvite": "发送邀请",
    "sendingInvite": "发送中...",
    "upgradeFeatureName": "团队协作",
    "upgradeFeatureDescription": "邀请团队成员共同协作指南和 SOP。",
    "upgradeBenefit1": "邀请无限数量的团队成员",
    "upgradeBenefit2": "分配角色和权限",
    "upgradeBenefit3": "实时协作指南"
  },
  "upgradeDialog": {
    "title": "升级到 Pro",
    "unlockFeature": "升级 Pro 版即可解锁{{feature}}及更多高级功能。",
    "unlockGeneric": "升级 Pro 版即可解锁高级功能。",
    "cta": "升级到 Pro",
    "learnMore": "了解更多套餐"
  },
  "integrations": {
    "title": "集成",
    "subtitle": "连接您常用的工具，以导入和导出内容。",
    "tabAvailable": "可用集成",
    "tabConnected": "已连接的集成",
    "loadingAvailable": "加载集成中...",
    "loadingConnected": "加载已连接的集成中...",
    "noActiveIntegrations": "暂无已激活的集成。请从「可用集成」选项卡连接一个。",
    "removeIntegrationTitle": "移除集成",
    "removeIntegrationDescription": "确定要移除此集成吗？此操作无法撤销。",
    "removeButton": "移除",
    "removedSuccess": "集成已成功移除",
    "publishToZendesk": "发布到 Zendesk",
    "noProviderFound": "未找到集成对应的服务方",
    "upgradeToPro": "升级到 Pro",
    "comingSoon": "即将推出",
    "connect": "连接",
    "manage": "管理",
    "upgradeFeatureName": "第三方集成",
    "upgradeFeatureDescription": "将您的文档与流行的第三方平台连接",
    "upgradeBenefit1": "将 SOP 导出到 Notion、Google Docs 和 Confluence",
    "upgradeBenefit2": "跨多个平台同步数据",
    "upgradeBenefit3": "在一处轻松管理所有集成"
  },
  "settingsLayout": {
    "title": "设置",
    "subtitle": "管理您的工作区与账户偏好。"
  },
  "settingsNav": {
    "organization": "组织",
    "compliance": "合规",
    "writing": "写作",
    "apiKeys": "API 密钥",
    "billing": "账单",
    "signing": "签名",
    "profile": "个人资料",
    "security": "安全",
    "general": "通用",
    "publishing": "发布",
    "properties": "属性",
    "members": "成员",
    "auditLogs": "审计日志",
    "mcpServer": "MCP 服务器",
    "branding": "品牌",
    "templates": "样式",
    "themeSelect": "主题"
  },
  "security": {
    "title": "安全",
    "subtitle": "管理您的账户安全设置。",
    "twoFactorTitle": "两步验证",
    "twoFactorBlurb": "使用身份验证器应用为您的账户添加额外的安全层。",
    "enabled": "已启用",
    "disabled": "已禁用",
    "twoFactorEnabledNote": "您的账户已受两步验证保护。",
    "twoFactorDisabledNote": "两步验证在登录时要求输入身份验证器应用中的代码，为账户增加额外的安全保护。",
    "enableTwoFactor": "启用两步验证",
    "disableTwoFactor": "禁用两步验证",
    "disableTwoFactorToast": "两步验证已禁用",
    "enableTwoFactorTitle": "启用两步验证",
    "enablePasswordDescription": "输入您的密码以继续设置两步验证。",
    "passwordLabel": "密码",
    "passwordPlaceholder": "输入您的密码",
    "forgotPassword": "忘记密码？",
    "continue": "继续",
    "scanQRTitle": "扫描二维码",
    "scanQRDescription": "使用身份验证器应用（Google Authenticator、Authy 等）扫描此二维码。",
    "manualEntryCode": "手动输入代码",
    "manualEntryHint": "如果无法扫描二维码，请将此代码手动输入到您的身份验证器应用中。",
    "nextVerify": "下一步：验证代码",
    "verifySetupTitle": "验证设置",
    "verifySetupDescription": "输入身份验证器应用中的 6 位验证码以确认设置。",
    "back": "返回",
    "verifyEnable": "验证并启用",
    "saveBackupTitle": "保存您的备用代码",
    "saveBackupDescription": "请妥善保存这些代码。如果您丢失了身份验证器设备，可以使用它们访问账户。每个代码只能使用一次。",
    "clickToCopy": "点击复制",
    "copyAll": "全部复制",
    "download": "下载",
    "savedCodes": "我已保存这些代码",
    "verifyIdentityTitle": "验证您的身份",
    "verifyIdentityDescription": "出于安全考虑，请输入身份验证器应用中的代码以继续。",
    "verifyContinue": "验证并继续",
    "confirmDisableTitle": "确认禁用两步验证",
    "confirmDisableDescription": "输入您的密码以确认禁用两步验证。",
    "resetPasswordTitle": "重置您的密码",
    "resetPasswordDescription": "我们已向 {{email}} 发送了一个验证码。请在下方输入验证码和新密码。",
    "verificationCode": "验证码",
    "newPassword": "新密码",
    "newPasswordPlaceholder": "输入新密码（至少 8 个字符）",
    "confirmPasswordLabel": "确认密码",
    "confirmPasswordPlaceholder": "再次输入新密码",
    "resendCode": "重新发送验证码",
    "resetPassword": "重置密码",
    "verificationCodeSentToast": "验证码已发送到您的邮箱",
    "passwordResetToast": "密码重置成功！",
    "noEmailError": "未找到您账户的邮箱地址",
    "failedToSendCode": "发送验证码失败",
    "failedToResetPassword": "重置密码失败",
    "failedEnableTwoFactor": "启用两步验证失败",
    "failedDisableTwoFactor": "禁用两步验证失败",
    "invalidVerificationCode": "验证码无效",
    "pleaseEnter6Digit": "请输入 6 位验证码",
    "passwordMinLength": "密码长度至少为 8 个字符",
    "passwordsDoNotMatch": "两次输入的密码不一致",
    "genericError": "发生错误，请重试。",
    "noCodeToCopy": "没有可复制的代码",
    "copiedToClipboard": "已复制到剪贴板",
    "backupCodesDownloaded": "备用代码已下载",
    "changePasswordTitle": "修改密码",
    "changePasswordSubtitle": "更新您的账户密码。",
    "currentPasswordLabel": "当前密码",
    "currentPasswordPlaceholder": "输入当前密码",
    "newPasswordLabel": "新密码",
    "confirmNewPasswordLabel": "确认新密码",
    "changePasswordButton": "修改密码",
    "enterCurrentPasswordError": "请输入当前密码",
    "newPasswordMinError": "新密码长度至少为 8 个字符",
    "passwordChangedToast": "密码修改成功",
    "failedChangePassword": "修改密码失败"
  },
  "workspaceView": {
    "addSop": "添加 SOP",
    "tabSops": "SOP",
    "tabMembers": "成员",
    "tabSettings": "设置",
    "sopsCount_other": "{{count}} 个 SOP",
    "search": "搜索...",
    "colName": "名称",
    "colApplication": "应用",
    "colSteps": "步骤数",
    "colCreatedBy": "创建者",
    "colAction": "操作",
    "loadingSops": "加载 SOP 中...",
    "noSopsFound": "未找到 SOP",
    "tryDifferentSearch": "请尝试其他搜索词。",
    "startRecordingHint": "开始一段屏幕录制来创建您的第一个 SOP。",
    "untitledSop": "未命名 SOP",
    "sopDeleted": "SOP 已删除",
    "sopDeleteFailed": "删除 SOP 失败：{{error}}",
    "sopRemoved": "SOP 已从工作区移除",
    "sopRemoveFailed": "移除 SOP 失败：{{error}}",
    "removeFromWorkspaceTitle": "从工作区移除",
    "removeFromWorkspaceDesc": "这将从此工作区中移除「{{title}}」。原始 SOP 不会被删除。",
    "deleteSopTitle": "删除 SOP",
    "deleteSopDesc": "确定要删除「{{title}}」吗？此操作无法撤销。",
    "remove": "移除",
    "membersCount_other": "{{count}} 位成员",
    "pendingCount": "· 待处理 {{count}} 个",
    "inviteMember": "邀请成员",
    "noPermissionInviteMembers": "您没有邀请成员的权限",
    "inviteMemberTitle": "邀请成员",
    "inviteMemberDesc": "邀请新成员加入此工作区",
    "emailAddress": "邮箱地址",
    "enterEmailAddress": "输入邮箱地址",
    "role": "角色",
    "selectRole": "选择角色",
    "roleAdmin": "管理员",
    "roleAdminDesc": "拥有管理工作区的完整权限",
    "roleCollaborator": "协作者",
    "roleCollaboratorDesc": "可以编辑和评审内容",
    "sendInvite": "发送邀请",
    "sending": "发送中...",
    "colMember": "成员",
    "colRole": "角色",
    "colStatus": "状态",
    "loadingMembers": "加载成员中...",
    "noMembersYet": "暂无成员",
    "inviteTeamHint": "邀请团队成员共同协作 SOP。",
    "statusPending": "待加入",
    "statusActive": "已激活",
    "roleOwner": "所有者",
    "invitationSent": "邀请已发送",
    "invitationFailed": "邀请发送失败：{{error}}",
    "removeMemberTitle": "移除成员",
    "removeMemberDesc": "确定要将「{{name}}」从此工作区移除吗？",
    "roleUpdated": "角色已更新",
    "failedUpdateRole": "更新角色失败",
    "memberRemoved": "成员已移除",
    "failedRemoveMember": "移除成员失败",
    "settingsGeneral": "通用",
    "workspaceName": "工作区名称",
    "description": "描述",
    "color": "颜色",
    "saveChanges": "保存更改",
    "saving": "保存中...",
    "workspaceUpdated": "工作区已更新",
    "workspaceUpdateFailed": "更新工作区失败：{{error}}"
  },
  "signup": {
    "title": "创建您的账户",
    "subtitle": "几分钟内即可开始创建出色的文档",
    "continueWithGoogle": "使用 Google 账户继续",
    "continueWithGithub": "使用 GitHub 账户继续",
    "or": "或",
    "fullNameLabel": "姓名",
    "fullNamePlaceholder": "张三",
    "emailLabel": "邮箱",
    "emailPlaceholder": "name@example.com",
    "passwordLabel": "密码",
    "passwordPlaceholder": "至少 8 个字符",
    "agreeTerms": "我同意",
    "termsOfService": "服务条款",
    "and": "与",
    "privacyPolicy": "隐私政策",
    "createAccount": "创建账户",
    "creatingAccount": "创建中...",
    "alreadyHaveAccount": "已有账户？",
    "signIn": "登录",
    "errorEnterName": "请输入您的姓名",
    "errorNameTooLong": "姓名过长",
    "errorEnterEmail": "请输入您的邮箱",
    "errorInvalidEmail": "邮箱地址无效",
    "errorPasswordMin": "密码长度至少为 8 个字符",
    "errorMustAgreeTerms": "您必须同意服务条款",
    "accountCreated": "账户已创建！请验证您的邮箱。",
    "verificationCodeSent": "我们已向 {{email}} 发送了一个验证码",
    "failedCreateAccount": "创建账户失败",
    "failedCreateAccountRetry": "创建账户失败，请重试。",
    "cannotSignupWith": "无法使用 {{provider}} 注册：{{error}}"
  },
  "loginLayout": {
    "tagline": "把任何工作流变成一份鲜活的指南。",
    "description": "录制屏幕或导入 Loom 视频。Glyde 会把它变成团队可以照着做的分步指南——或在浏览器中直接演示。",
    "stat1Label": "已生成 SOP",
    "stat2Label": "活跃团队",
    "stat3Label": "节省时间",
    "stat4Label": "平均评分"
  },
  "membersTable": {
    "colUser": "用户",
    "colRole": "角色",
    "colStatus": "状态",
    "colDateJoined": "加入日期",
    "colActions": "操作",
    "statusActive": "已激活",
    "statusPending": "待加入",
    "roleOwner": "所有者",
    "roleAdmin": "管理员",
    "roleMember": "成员",
    "roleCollaborator": "协作者",
    "roleViewer": "查看者",
    "selectRole": "选择角色",
    "unnamedUser": "未命名用户",
    "noMembersMatchSearch": "未找到匹配的成员。",
    "noMembersFound": "未找到成员。",
    "cancelInvitationTitle": "取消邀请",
    "cancelInvitationDesc": "确定要取消此邀请吗？",
    "cancelInvitationConfirm": "取消邀请",
    "invitationCancelled": "邀请已取消",
    "failedCancelInvitation": "取消邀请失败",
    "invitationResent": "邀请已重新发送",
    "failedResendInvitation": "重新发送邀请失败",
    "roleUpdated": "角色已更新",
    "failedUpdateRole": "更新角色失败",
    "memberRemoved": "成员已移除",
    "failedRemoveMember": "移除成员失败：{{error}}"
  },
  "profileForm": {
    "profilePicture": "头像",
    "profilePictureHint": "请使用尺寸至少 132 像素见方的图片。",
    "upload": "上传",
    "remove": "移除",
    "firstName": "名",
    "lastName": "姓",
    "enterFirstName": "输入您的名",
    "enterLastName": "输入您的姓",
    "email": "邮箱",
    "enterEmail": "输入您的邮箱",
    "update": "更新",
    "saving": "保存中...",
    "updatedSuccess": "更新成功",
    "failedUpdate": "更新失败",
    "firstNameRequired": "请输入名",
    "uploadAvatarTitle": "上传头像",
    "uploadAvatarHint": "请使用尺寸至少 132 像素见方的图片。",
    "dragDropAvatar": "拖放头像到此处，或点击选择",
    "supportedFormats": "支持格式：PNG、JPG、JPEG",
    "uploading": "上传中"
  },
  "writingSettings": {
    "title": "写作",
    "subtitle": "为您的工作区自定义 AI 写作设置。",
    "guidelinesLabel": "写作指南",
    "guidelinesPlaceholder": "例如：\"面向开发者的技术文档。简洁、不使用术语。使用项目符号和代码示例。\"",
    "update": "更新",
    "saving": "保存中...",
    "updatedSuccess": "更新成功",
    "errorUpdating": "更新失败：{{message}}",
    "errorLoadingWorkspace": "加载工作区失败：{{message}}",
    "workspaceNotFound": "未找到工作区"
  },
  "organizationSettings": {
    "title": "组织",
    "organizationName": "组织名称",
    "organizationSlug": "组织标识符",
    "saveChanges": "保存更改",
    "saving": "保存中...",
    "updatedSuccess": "组织更新成功",
    "failedUpdate": "组织更新失败"
  },
  "sopEditor": {
    "guideMe": "引导我",
    "edit": "编辑",
    "cancel": "取消",
    "save": "保存",
    "share": "分享",
    "delete": "删除",
    "untitledSop": "未命名 SOP",
    "sops": "SOP",
    "addToWorkspace": "添加到工作区",
    "exportToNotion": "导出到 Notion",
    "exportToGoogleDocs": "导出到 Google Docs",
    "exportToConfluence": "导出到 Confluence",
    "deleteSopTitle": "删除 SOP",
    "deleteSopDesc": "确定要删除「{{title}}」吗？此操作无法撤销。",
    "upgradeFeatureName": "添加到工作区",
    "upgradeFeatureDescription": "跨多个工作区共享 SOP，保持团队同步。",
    "upgradeBenefit1": "共享 SOP 到任意工作区",
    "upgradeBenefit2": "无限工作区",
    "upgradeBenefit3": "跨团队协作",
    "contents": "目录",
    "details": "详情",
    "category": "分类",
    "created": "创建时间",
    "createdBy": "创建者",
    "waitingForContent": "等待内容...",
    "noHeadingsFound": "未找到标题",
    "toolbarImage": "图片",
    "personalSpace": "{{name}} 的空间"
  },
  "errorPages": {
    "pageNotFound": "页面未找到",
    "pageNotFoundDesc": "您要查找的页面不存在或已被移动。",
    "accessDenied": "访问被拒绝",
    "accessDeniedDesc": "您没有访问此页面的权限。请联系工作区管理员。",
    "goToDashboard": "返回首页",
    "goBack": "返回上一页",
    "somethingWentWrong": "出错了",
    "somethingWentWrongDesc": "很抱歉给您带来不便，请稍后重试。",
    "backToHome": "返回首页"
  },
  "billing": {
    "title": "账单",
    "subtitle": "管理您的订阅与账单设置。",
    "currentSubscription": "当前订阅",
    "statusActive": "已激活",
    "statusPastDue": "已逾期",
    "statusCanceled": "已取消",
    "statusPaused": "已暂停",
    "nextBillingDate": "下次扣费日期：{{date}}",
    "billedAnnually": "{{amount}} 按年付费",
    "teamSeats": "团队席位",
    "seat_other": "{{count}} 个席位",
    "manageSeats": "管理席位",
    "videoImports": "视频导入",
    "thisMonth": "本月",
    "unlimited": "无限",
    "monthly": "按月",
    "annual": "按年",
    "save20": "节省 20%",
    "currentPlan": "当前套餐",
    "contactUs": "联系我们",
    "upgrade": "升级",
    "manageSubscription": "管理订阅",
    "subscriptionUpdated": "订阅更新成功！",
    "checkoutCanceled": "结账已取消。",
    "perMonth": "/月",
    "planFreeName": "免费版",
    "planProName": "高级版",
    "planEnterpriseName": "企业版",
    "planFreeDescription": "25 篇指南，1 个工作区",
    "planProDescription": "无限指南，团队工作区",
    "planEnterpriseDescription": "SSO、审计日志、API 密钥",
    "partnerBillingTitle": "账单与订阅",
    "partnerBillingSubtitle": "管理您的账单与订阅设置",
    "partnerManagedTitle": "合作伙伴管理的账单",
    "partnerManagedDesc1": "您的账单与订阅由合作伙伴组织管理",
    "partnerManagedDesc2": "如需升级套餐、增加工作区数量或修改账单设置，请直接联系您的合作伙伴组织。",
    "partnerManagedOrgTitle": "合作伙伴管理的组织",
    "partnerManagedOrgDesc": "此组织由合作伙伴管理",
    "partnerOrgLabel": "合作伙伴组织",
    "partnerOrgFallback": "合作伙伴组织",
    "partnerManagedBadge": "合作伙伴管理",
    "partnerManagesList": "合作伙伴管理：",
    "partnerManagesItem1": "套餐选择与升级",
    "partnerManagesItem2": "账单与付款方式",
    "partnerManagesItem3": "工作区分配限制",
    "partnerManagesItem4": "积分购买",
    "seatDialog": {
      "title": "团队席位",
      "currentUsage": "当前用量",
      "activeMembers": "活跃成员",
      "currentSeats": "当前席位",
      "seatsIncluded": "已含席位",
      "numberOfSeats": "席位数量",
      "continueToCheckout": "前往结算",
      "updateSeats": "更新席位",
      "updating": "更新中…",
      "redirecting": "跳转中…",
      "updateSuccess": "席位数量更新成功",
      "updateError": "更新席位数量失败",
      "firstSeatIncluded": "首个席位已包含在套餐中",
      "costAdding_other": "新增 {{count}} 个席位：${{cost}}/月（按比例计费）",
      "costRemoving_other": "移除 {{count}} 个席位",
      "additionalSeats_other": "{{count}} 个额外席位：+${{cost}}/月"
    }
  },
  "shareDialog": {
    "title": "分享 SOP",
    "subtitle": "控制谁可以访问此文档",
    "close": "关闭",
    "tabShare": "分享",
    "tabEmbed": "嵌入",
    "tabExport": "导出",
    "proBadge": "Pro",
    "embedProTitle": "嵌入是 Pro 功能",
    "embedProHint": "升级到 Pro 即可将 SOP 嵌入到 Notion、Confluence 等平台。",
    "invite": "邀请",
    "inviteEmailPlaceholder": "邮箱或群组，多个用逗号分隔",
    "inviteButton": "邀请",
    "invited": "已邀请",
    "invitationSent": "已向 {{email}} 发送邀请",
    "failedCreateInvitation": "创建邀请失败。",
    "shareLinkNotReady": "请等待分享链接生成。",
    "documentContextMissing": "缺少文档上下文",
    "shareToWeb": "分享到网络",
    "shareToWebEnableHint": "开启后，任何人通过链接均可查看",
    "shareToWebPublicHint": "任何拥有链接的人均可查看",
    "publicSharingEnabled": "公开分享已启用",
    "publicSharingDisabled": "公开分享已关闭",
    "failedUpdateSettings": "更新分享设置失败",
    "shareSettingsUpdated": "分享设置已更新",
    "failedUpdatePassword": "更新密码失败",
    "accessPassword": "访问密码",
    "optionPublic": "任何拥有链接的人",
    "optionPrivate": "仅受邀人员",
    "optionEmailDomains": "仅 {{domain}} 邮箱域名的用户",
    "optionPassword": "仅持有密码的用户",
    "shareToSocialMedia": "分享到社交媒体",
    "facebook": "Facebook",
    "x": "X",
    "linkedin": "LinkedIn",
    "email": "邮箱",
    "copyLink": "复制链接",
    "embedDescription": "在团队常用的平台中直接嵌入交互式版本。",
    "livePreview": "实时预览",
    "greatForKnowledgeBases": "适用于知识库",
    "copyEmbed": "复制嵌入代码",
    "previewWillAppear": "预览将在此处显示",
    "failedGenerateEmbed": "生成嵌入预览失败",
    "generationFailed": "生成失败",
    "exportToPdf": "导出为 PDF",
    "exportToPdfDesc": "与团队共享 PDF 或打印 PDF。",
    "exportToDocx": "导出为 DOCX",
    "exportToDocxDesc": "适用于 Microsoft Word 等办公应用。",
    "exportToMarkdown": "导出为 Markdown",
    "exportToMarkdownDesc": "适用于 GitHub 等应用。",
    "export": "导出",
    "pdfExported": "PDF 已导出",
    "docxExported": "DOCX 已导出！",
    "markdownExported": "Markdown 已导出！",
    "htmlExported": "HTML 已导出！",
    "failedExport": "导出失败：{{message}}",
    "failedExportDocx": "导出 DOCX 失败：{{message}}",
    "failedExportMarkdown": "导出 Markdown 失败：{{message}}",
    "failedExportHtml": "导出 HTML 失败：{{message}}",
    "failedGetDownloadLink": "获取下载链接失败",
    "documentNotFound": "未找到文档",
    "noTopicSelected": "未选择主题",
    "noDocumentFound": "未找到该主题对应的文档",
    "failedResolveDocument": "解析文档失败：{{message}}",
    "unableToShareSop": "无法分享 SOP，请确认 SOP 已加载",
    "unableToShareDoc": "无法分享文档，请确认文档已加载",
    "unableToGetDocId": "无法获取文档 ID，请确认文档已加载",
    "failedGenerateSopLink": "生成 SOP 分享链接失败，请重试",
    "failedGenerateShareLink": "生成分享链接失败，请重试",
    "pleaseGenerateLinkFirst": "请先生成分享链接"
  },
  "importVideo": {
    "title": "导入视频生成 SOP",
    "description": "上传屏幕录制视频即可自动生成标准操作流程（SOP）。准备就绪后您将收到邮件通知。",
    "dropHint": "将视频文件拖到此处，或点击浏览",
    "supports": "支持 MP4、WebM、MOV（最大 20MB）",
    "generateButton": "从视频生成 SOP",
    "uploading": "上传中...",
    "chooseDifferent": "选择其他文件",
    "fileTooLarge": "文件过大。最大不超过 20MB。",
    "unsupportedFormat": "格式不支持。请使用 MP4、WebM 或 MOV。",
    "uploadFailed": "上传失败",
    "uploadTimeout": "上传超时。请检查网络后重试。",
    "videoSubmitted": "视频已提交处理。SOP 准备就绪后将通过邮件通知您。",
    "monthlyLimitReached": "本月视频导入额度已用完（{{current}}/{{limit}}）",
    "upgradeHint": "升级套餐以导入更多视频。"
  },
  "navUser": {
    "profile": "个人资料",
    "logOut": "退出登录",
    "owner": "所有者",
    "logOutTitle": "确认退出登录？",
    "logOutDesc": "您需要重新登录才能访问工作区。"
  },
  "extensionAlert": {
    "title": "安装扩展",
    "description": "轻松录制屏幕并捕获内容",
    "getExtension": "获取扩展"
  },
  "feedback": {
    "trigger": "反馈",
    "ariaLabel": "向 Tao 发送反馈",
    "title": "向 Tao 发送反馈",
    "intro1": "你好，我是 Glyde 创始人 Tao。我们打造 Glyde，是因为厌倦了写没人看的 SOP，以及用过时、半成品的文档来培训新同事。我们每周都在改进，而你的反馈决定了下一步会做什么。",
    "intro2": "告诉我哪里有问题、令人困惑或有所缺失——bug、想法、不成熟的念头，什么都行。它会直接进入我的收件箱，我会阅读每一条。",
    "placeholder": "你在想些什么？",
    "includeScreenshot": "包含本页面的截图",
    "capturing": "截图中…",
    "cancel": "取消",
    "send": "发送",
    "sending": "发送中…",
    "successToast": "感谢反馈——Tao 会看到的。",
    "errorToast": "反馈发送失败，请重试。"
  }
}
